<template>
  <b-container fluid class="">
    <b-row class="justify-content-between">
      <b-col cols="12" md="6" class="w-100">
        <h3>{{ $t('sales.users.event.title')}} - {{ event.name }} - {{ user.username }}</h3>
      </b-col>
      <b-col cols="12" md="6" class="w-100">
        <b-btn class="float-right" v-b-modal.createAssignment variant="primary">
              <span class="fas fa-plus mx-2"></span>
              {{ $t('sales.users.event.button')}}
            </b-btn>
      </b-col>
    </b-row>

    <!-- <hr />

    <b-row>
      <b-col cols="12" lg="6">
        <b-row class>
          <b-col cols="12" class>
            <h5>{{ $t('sales.users.event.actions')}}</h5>
          </b-col>
        </b-row>
        <b-row class="py-2 flex-center">
          <b-col cols class>
            <b-btn v-b-modal.createAssignment variant="primary">
              <span class="fas fa-plus mx-2"></span>
              {{ $t('sales.users.event.button')}}
            </b-btn>
          </b-col>
        </b-row>
      </b-col> 
    </b-row> -->

    <hr />

    <b-container fluid class="">
    <b-row class="p-2 justify-content-center">
      <b-col cols="12" lg="3" class="saleDash m-2 p-4 shadow-lg">
          <b-row>
            <b-col cols="4">
              <i class="fas fa-chart-line fa-3x"></i>
            </b-col>
            <b-col cols="8">
              <b-card-title class="text-right">{{ $t('sales.users.event.sold')}}:</b-card-title>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="9">
              <b-card-text class="text-right">
                <h3 v-if="totalSold">{{ totalSold }}</h3>
                <h3 v-else>0</h3>
              </b-card-text>
            </b-col>
            <b-col cols="3">
              <b-card-text class="total">
                <p style="color: #BCBCBC" v-if="totalAssigned">/{{ totalAssigned }}</p>
                <p style="color: #BCBCBC" v-else>/0</p>
              </b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-progress height="1.5rem" class="w-100">
                <b-progress-bar
                  :value="calculatePercentage(totalSold,totalAssigned)"
                  :label="calculatePercentage(totalSold,totalAssigned)+'%'"
                ></b-progress-bar>
              </b-progress>
            </b-col>
          </b-row>
      </b-col>
      <b-col  cols="12" lg="3" class="saleDash m-2 p-4 shadow-lg">
          <b-row>
            <b-col cols="4">
              <i class="fas fa-cash-register fa-3x"></i>
            </b-col>
            <b-col cols="8">
              <b-card-title class="text-right">{{ $t('sales.users.event.profit')}}:</b-card-title>
            </b-col>
          </b-row>

          <b-card-text class="text-right">
            <h4>{{ totalProfit }} KM</h4>
          </b-card-text>
      </b-col>

      <b-col  cols="12" lg="3" class="saleDash m-2 p-4 shadow-lg">
          <b-row>
            <b-col cols="4">
              <i class="fas fa-tasks fa-2x"></i>
            </b-col>
            <b-col cols="8">
              <b-card-title class="text-right">{{ $t('sales.users.event.done')}}:</b-card-title>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="9">
              <b-card-text class="text-right">
                <h3 v-if="totalSold">{{ done }}</h3>
                <h3 v-else>0</h3>
              </b-card-text>
            </b-col>
            <b-col cols="3">
              <b-card-text class="total">
                <p style="color: #BCBCBC" v-if="totalAssigned">/{{ assignments.length }}</p>
                <p style="color: #BCBCBC" v-else>/0</p>
              </b-card-text>
            </b-col>
          </b-row>
      </b-col>
    </b-row>
    </b-container>

    <hr />
    <b-container fluid class="p-2">
    <b-row class="w-100 noMargin justify-content-center">
      <b-col cols="12" md="3" class="eventDash m-2 p-4 shadow-lg" v-for="item in assignments">
        <b-row style="margin-bottom: 5%">
          <b-col cols="10">
            <h6 class="text-left">{{ item.name.toUpperCase() }}</h6>
          </b-col>
          <b-col cols="2">
            <span v-show="parseInt(item.total)>parseInt(item.total_sold)" class="flex-center">
              <i
                v-b-modal.deleteAssignment
                class="fas fa-trash-alt mx-2"
                @click="assignmentDeleteId = item.id"
                v-b-popover.hover.right="$t('hover.remove')"
              ></i>
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
            <p
              style="color: #BCBCBC"
              v-b-popover.hover.left="$t('sales.users.event.card.date')"
            >{{ item.created_at | moment('DD.MM.YYYY') }}</p>
          </b-col>
          <b-col cols="3">
            <span v-b-popover.hover.left="$t('sales.users.event.card.price')">{{ item.price }} KM</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
            <b-row>
              <b-col cols="1">
                <b-card-text class="text-left">
                  <h3
                    v-b-popover.hover.left="$t('sales.users.event.card.sold')"
                  >{{ item.total_sold }}</h3>
                </b-card-text>
              </b-col>
              <b-col cols="1">
                <b-card-text class="text-left">
                  <p
                    style="color: #BCBCBC"
                    v-if="totalAssigned"
                    v-b-popover.hover.left="$t('sales.users.event.card.tickets')"
                  >/{{ item.total }}</p>
                </b-card-text>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="3" style="color: #BCBCBC">
            <p>{{calculatePercentage(item.total_sold,item.total)}} %</p>
          </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-progress
                    height="1rem"
                    :value="calculatePercentage(item.total_sold,item.total)"
                    class="w-100"
                    ></b-progress>

            </b-col>
        </b-row>
        
      </b-col>
    </b-row>
    </b-container>

    <b-modal centered id="deleteAssignment" title @ok="deleteAssignment" ok-variant="danger">
      <template v-slot:modal-title>{{$t('prepaid.group.card.modal.delTitle')}}</template>
      <p class="my-4">{{$t('sales.users.delete')}}</p>
    </b-modal>

    <b-modal centered no-close-on-backdrop id="createAssignment" title hide-footer>
      <template v-slot:modal-title>{{$t('sales.users.event.modal.title')}}</template>
      <b-col md="12">
        <b-form @submit.prevent="createAssignment()" data-vv-scope="createAssignment">
          <b-row>
            <b-col cols="12">
              <b-form-group label-for="name">
                {{ $t('sales.users.event.modal.name') }}
                <b-form-input
                  :state="validateState('createAssignment.name')"
                  :class="{'is-invalid': veeErrors.has('createAssignment.name')}"
                  v-validate="'required|min:4'"
                  v-model="assignment.name"
                  id="name"
                  ref="name"
                  type="text"
                  size="md"
                  name="name"
                ></b-form-input>
                <span class="vvError">{{ veeErrors.first('createAssignment.name') }}</span>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-for="ticketsFrom">
                {{ $t('sales.users.event.modal.from') }}
                <b-form-input
                  :state="validateState('createAssignment.ticketsFrom')"
                  :class="{'is-invalid': veeErrors.has('createAssignment.ticketsFrom')}"
                  v-validate="'required|min:1'"
                  v-model="assignment.tickets_from"
                  id="ticketsFrom"
                  ref="ticketsFrom"
                  type="number"
                  size="md"
                  name="ticketsFrom"
                ></b-form-input>
                <span class="vvError">{{ veeErrors.first('createAssignment.ticketsFrom') }}</span>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-for="ticketsTo">
                {{ $t('sales.users.event.modal.to') }}
                <b-form-input
                  :state="validateState('createAssignment.ticketsTo')"
                  :class="{'is-invalid': veeErrors.has('createAssignment.ticketsTo')}"
                  v-validate="'required|min:1'"
                  v-model="assignment.tickets_to"
                  id="ticketsTo"
                  ref="ticketsTo"
                  type="number"
                  size="md"
                  name="ticketsTo"
                ></b-form-input>
                <span class="vvError">{{ veeErrors.first('createAssignment.ticketsTo') }}</span>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-for="price">
                {{ $t('sales.users.event.modal.price') }}
                <b-form-input
                  :state="validateState('createAssignment.price')"
                  :class="{'is-invalid': veeErrors.has('createAssignment.price')}"
                  v-validate="'required|min:1'"
                  v-model="assignment.price"
                  id="price"
                  ref="price"
                  type="number"
                  size="md"
                  name="price"
                ></b-form-input>
                <span class="vvError">{{ veeErrors.first('createAssignment.price') }}</span>
              </b-form-group>
            </b-col>
            <b-col cols="6" class="flex-center">
              <b-form-group label-for="assignmentType" name="assignmentType">
                <b-form-radio
                  v-model="assignment.type"
                  name="assignmentType"
                  inline
                  value="1"
                >{{ $t('sales.users.event.modal.radio.in')}}</b-form-radio>
                <b-form-radio
                  v-model="assignment.type"
                  name="assignmentType"
                  inline
                  value="2"
                >{{ $t('sales.users.event.modal.radio.sold')}}</b-form-radio>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="float-right">
            <b-button
              type="submit"
              variant="primary"
              :disabled="veeErrors.any('createAssignment')"
            >{{ $t('sales.users.event.modal.button')}}</b-button>
          </b-row>
        </b-form>
      </b-col>
    </b-modal>
  </b-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "dashboardEvent",
  data() {
    return {
      done: 0,
      user: {},
      event: {},
      printError: "toast.printError",
      eventAssignments: {
        total: 0,
        total_sold: 0
      },
      assignment: {
        type: 1
      },
      assignments: [],
      assignmentDeleteId: 0,
      assignmentsFields: [
        {
          key: "name",
          label: "Name",
          sortable: true
        },
        {
          key: "total",
          label: "Tickets assigned",
          sortable: true
        },
        {
          key: "created_at",
          label: "Date assigned",
          sortable: true,
          formatter: value => this.$moment(value).format("DD.MM.YYYY.")
        }
      ]
    };
  },
  computed: {
    totalProfit() {
      if (this.assignments) {
        let sum = 0;
        this.assignments.forEach(function(item) {
          sum += parseFloat(item.price) * parseFloat(item.total_sold);
        });
        return sum;
      } else {
        return 0;
      }
    },
    totalSold() {
      if (this.assignments) {
        let sum = 0;
        this.assignments.forEach(function(item) {
          sum += parseInt(item.total_sold);
        });
        return sum;
      } else {
        return 0;
      }
    },
    totalAssigned() {
      if (this.assignments) {
        let sum = 0;
        this.assignments.forEach(function(item) {
          sum += parseInt(item.total);
        });
        return sum;
      } else {
        return 0;
      }
    }
  },
  methods: {
    calculatePercentage(sold, total) {
      if (sold == 0 || total == 0) {
        return 0;
      }
      if (parseInt((sold / total) * 100) === 100) {
        //this.done++;
      }
      return parseInt((sold / total) * 100);
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    getUser() {
      this.$axios
        .get("sales/user", {
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.user = response.data.data[0];
          }
        });
    },
    getEvent() {
      this.$axios
        .get("/events/getById", {
          params: {
            id: this.$route.params.event_id
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.event = response.data.data;
          }
        });
    },
    getAssignments() {
      var self = this;
      this.$axios
        .get("sales/userAssignments", {
          params: {
            id: this.$route.params.id,
            event_id: this.$route.params.event_id
          }
        })
        .then(response => {
          if (response.status === 200) {
            self.done = 0;
            this.assignments = response.data.data;
            this.assignments.forEach(assignment => {
              if (assignment.total_sold / assignment.total === 1) {
                self.done++;
              }
            });
          }
        });
    },
    getEventAssignment() {
      this.$axios
        .get("sales/userEvent", {
          params: {
            event_id: this.$route.params.event_id,
            id: this.$route.params.id
          }
        })
        .then(response => {
          if (response.data.success) {
            this.eventAssignments = response.data.data;
          } else {
            this.$toasted.global.err({
              message: this.$t(response.data.data.msg)
            });
          }
        });
    },
    goToUserEventSales(id) {
      this.$router.push("/sales/users/" + this.$route.params.id + "/" + id);
    },
    createAssignment() {
      this.$validator.validateAll("createAssignment").then(result => {
        if (!result) {
          this.$toasted.global.err({
            message: this.$t(this.printError)
          });
        } else {
          this.$axios
            .post("sales/createAssignment", {
              params: {
                assignment: this.assignment,
                id: this.$route.params.id,
                event_id: this.$route.params.event_id
              }
            })
            .then(response => {
              if (response.data.success) {
                this.assignment = response.data.data;
                this.$toasted.global.success({
                  message: this.$t(response.data.data.msg)
                });
              } else {
                this.$toasted.global.err({
                  message: this.$t(response.data.data.msg)
                });
              }
            })
            .then(() => {
              this.$nextTick(() => {
                this.veeErrors.clear();
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              });
            });
        }
      });
    },
    deleteAssignment() {
      this.$axios
        .post("sales/deleteAssignmentById", {
          params: {
            assignmentId: this.assignmentDeleteId
          }
        })
        .then(response => {
          if (response.data.success) {
            this.assignmentDeleteId = 0;
            this.$toasted.global.success({
              message: this.$t(response.data.data.msg)
            });
          } else {
            this.$toasted.global.err({
              message: this.$t(response.data.data.msg)
            });
          }
        });
    }
  },
  created() {
    let self = this;
    this.getUser();
    this.getAssignments();
    this.getEvent();
    this.series;
    this.interval = setInterval(function() {
      self.getAssignments();
    }, 3000);
  },
  destroyed() {
    clearInterval(this.interval);
  }
};
</script>

<style  lang="scss">
.salesDash {
  color: #fff;
  background-image: url("../../assets/img/login.jpg") !important;
  border: 5px solid #fff;
  border-radius: 10px;
}
.salesDash i {
  &:hover {
    cursor: pointer;
  }
}
.card {
  min-height: 140px;
  max-height: 140px;
}
.total {
  bottom: -15px;
}
.progress-bar {
  font-size: 13px !important;
}
</style>